import React from 'react';
import { styled, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { currencyFixedDigitsFormat } from 'src/utils/number';
import useGetCurrency from 'src/frontend-common/hooks/useGetCurrency';
interface BillingProduct {
  name: string;
  rate: string | number;
  detailsLink: string;
  apiLink: string;
}

export interface BillingProductsListProps {
  list: (BillingProduct | undefined)[];
}

const BillingProductsList: React.FC<BillingProductsListProps> = ({ list: listOfProducts }) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Products</TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {listOfProducts?.map((product, index) => {
          return (
            <TableRow key={`${product?.name}-${index}`}>
              <TableCell>{product?.name}</TableCell>
              <TableCellMaxWidth>
                {currencyFixedDigitsFormat(product?.rate ? Number(product?.rate) : 0, 2, { value: useGetCurrency(), currencyPosition: 'left' })}
              </TableCellMaxWidth>
              {product?.detailsLink !== '' && (
                <TableCellMaxWidth>
                  <DetailsAnchor href={product?.detailsLink} target="_blank" rel="noreferrer">
                    Details
                  </DetailsAnchor>
                </TableCellMaxWidth>
              )}
              <TableCellMaxWidth>
                <ApiAnchor href={product?.apiLink} target="_blank" rel="noreferrer">
                  API
                </ApiAnchor>
              </TableCellMaxWidth>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default BillingProductsList;

const TableCellMaxWidth = styled(TableCell)({
  width: 80,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const LinkButton = styled('a')(() => ({
  borderRadius: '5px',
  textTransform: 'capitalize',
  padding: '5px 10px',
  textDecoration: 'none',
  fontSize: 14,
  fontWeight: 500,
}));

const DetailsAnchor = styled(LinkButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.primary.main,
  color: 'white',
}));

const ApiAnchor = styled(LinkButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.light}`,
  color: theme.palette.primary.main,
  textTransform: 'uppercase',
}));
